import {html} from "lit";
import {customElement} from "lit/decorators/custom-element.js";
import {Login} from "../authentication/login.interface";
import {AbstractLitElement} from "../components/abstract-lit.element";

@customElement(`ha-login-view`)
export class HaLoginView extends AbstractLitElement {

    protected render(): unknown {
        const login: Login = {
            uid: `login`,
            identifier: `login`,
            username: ``,
            password: ``
        };

        return html`
            <dialog open>
                <header class="dialog__header">
                    <div class="dialog__header__title">
                        PLEASE LOGIN
                    </div>
                </header>
                <main class="dialog__main">
                    <ha-form-login .value=${login}></ha-form-login>
                </main>
            </dialog>
        `;
    }
}